var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSi = function SvgSi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#si_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 12.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C6.04 6 7.16 6 9.4 6h13.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C29 9.04 29 10.16 29 12.4v7.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C25.96 26 24.84 26 22.6 26H9.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C3 22.96 3 21.84 3 19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D7D7D7",
    strokeWidth: 0.3,
    d: "M.85 5.85h30.3v20.3H.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillRule: "evenodd",
    d: "M1 26h30V6H1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005CE5",
    fillRule: "evenodd",
    d: "M1 19.333h30V6H1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M1 12.667h30V6H1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005CE5",
    fillRule: "evenodd",
    d: "m8.856 9.507-.143.001a6.6 6.6 0 0 0-2.419.52l-.198.08.214 3.116c.147 1.628 1.284 2.578 2.547 2.95 1.264-.372 2.402-1.322 2.549-2.95l.213-3.106q-.097-.045-.199-.09a6.6 6.6 0 0 0-2.561-.52h-.003",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8.167 14.605c-.23 0-.46.172-.69.172a1 1 0 0 1-.143-.013c.398.496.94.828 1.523 1.019.582-.191 1.125-.523 1.522-1.018a1 1 0 0 1-.14.012c-.23 0-.462-.172-.692-.172-.228 0-.458.172-.69.172-.23 0-.46-.172-.69-.172m0-.362c-.23 0-.46.17-.69.17a.8.8 0 0 1-.46-.145q.064.129.139.245a.64.64 0 0 0 .321.092c.23 0 .46-.17.69-.17s.46.17.69.17c.232 0 .462-.17.69-.17.23 0 .462.17.692.17a.64.64 0 0 0 .317-.09q.075-.117.139-.244a.8.8 0 0 1-.456.142c-.23 0-.462-.17-.692-.17-.228 0-.458.17-.69.17-.23 0-.46-.17-.69-.17m.69-2.58L8.234 12.8l-.402-.49-1.055 1.3q.03.121.066.235c.119.186.344.398.634.398.23 0 .46-.172.69-.172s.46.172.69.172c.232 0 .462-.172.69-.172.23 0 .462.172.692.172.287 0 .511-.208.63-.392q.039-.12.067-.243L9.884 12.31l-.402.489z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE500",
    fillRule: "evenodd",
    d: "M7.82 9.924h.522l-.26.421",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE500",
    fillRule: "evenodd",
    d: "M7.82 10.205h.522l-.26-.421M9.374 9.924h.521l-.26.421",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE500",
    fillRule: "evenodd",
    d: "M9.374 10.205h.521l-.26-.421M8.597 10.895h.521l-.26.422",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE500",
    fillRule: "evenodd",
    d: "M8.597 11.177h.521l-.26-.422",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillRule: "evenodd",
    d: "m6.294 10.029-.197.08.213 3.116c.148 1.629 1.285 2.577 2.548 2.949 1.263-.372 2.4-1.32 2.549-2.95l.211-3.106q-.096-.045-.197-.09l-.199 3.094c-.137 1.583-1.192 2.504-2.365 2.867-1.172-.363-2.229-1.284-2.365-2.867zm2.563-.522q-.075 0-.149.002z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#D7D7D7",
    strokeWidth: 0.5,
    d: "M3.25 12.4c0-1.124 0-1.952.054-2.607.053-.651.158-1.109.355-1.495a3.75 3.75 0 0 1 1.639-1.64c.386-.196.844-.301 1.495-.354.655-.054 1.483-.054 2.607-.054h13.2c1.124 0 1.952 0 2.607.054.651.053 1.109.158 1.495.355a3.75 3.75 0 0 1 1.64 1.639c.196.386.301.844.354 1.495.054.655.054 1.483.054 2.607v7.2c0 1.124 0 1.952-.054 2.607-.053.651-.158 1.109-.355 1.495a3.75 3.75 0 0 1-1.639 1.64c-.386.196-.844.301-1.495.354-.655.054-1.483.054-2.607.054H9.4c-1.124 0-1.952 0-2.607-.054-.651-.053-1.109-.158-1.495-.355a3.75 3.75 0 0 1-1.64-1.639c-.196-.386-.301-.844-.354-1.495-.054-.655-.054-1.483-.054-2.607z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "si_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 12.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C6.04 6 7.16 6 9.4 6h13.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C29 9.04 29 10.16 29 12.4v7.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C25.96 26 24.84 26 22.6 26H9.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C3 22.96 3 21.84 3 19.6z"
  })))));
};
export default SvgSi;